import { TheNightlySection } from '@news-mono/common'
import { sectionThemeOverrider } from '@news-mono/component-library'
import { GetRouteAdTargeting, PageType } from '@news-mono/web-common'
import { layout } from '../../../App.routing'

type CreateElectionPageArgs = {
    heading: string
    description: string
    getAdTargeting: GetRouteAdTargeting
}

export const createElectionPage = ({
    heading,
    description,
    getAdTargeting,
}: CreateElectionPageArgs): PageType<TheNightlySection> => {
    return {
        kind: 'page',
        heading,
        pageType: 'static',
        section: 'politics',
        hideHeading: true,
        adTargeting: getAdTargeting('home', 'default', 'home'),
        pageMeta: {
            description,
        },
        socialMeta: {
            description,
        },
        compositions: [
            layout.composition({
                type: 'scheme-overrider',
                props: {
                    override: sectionThemeOverrider('thenightly', 'politics'),
                },
                contentAreas: {
                    children: [
                    ],
                },
            }),
        ],
    }
}
